// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ImageStack = React.forwardRef(function ImageStack(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ImageStack" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 2.99999L23 3V17.05L5 17.05V2.99999ZM20.36 13.475H8.04L11.12 7.91391L13.0931 11.506L16.125 6.32502L20.36 13.475Z", fill: "currentColor" }),
            React.createElement("path", { d: "M1 21H20V19H3V6.00002H1V21Z", fill: "currentColor" }))));
});
ImageStack.displayName = 'ImageStack';
export default ImageStack;
//# sourceMappingURL=ImageStack.js.map